import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthApiService } from '../../../services/auth.api.service';
import { userFacingErrorMessage } from '../../../utils/user-facing-error';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrl: './verify-email.component.scss',
  standalone: false,
})
export class VerifyEmailComponent {
  isLoading = true;
  message: string | null = null;
  error: string | null = null;

  constructor(private route: ActivatedRoute, private router: Router, private authApi: AuthApiService) {}

  ngOnInit() {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (!token) {
      this.isLoading = false;
      this.error = 'Missing verification token.';
      return;
    }

    this.authApi.verifyEmail(token).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.message = res?.message || 'Email verified successfully.';
      },
      error: (err) => {
        console.error('Verify email failed', err);
        this.isLoading = false;
        this.error = userFacingErrorMessage(err, 'verifyEmail');
      },
    });
  }

  goToLogin = (_e?: Event) => {
    this.router.navigate(['/login']);
  };
}

